import React, { FC, useCallback, useRef, useState } from 'react';
import { IconCaretDownFill } from '@saucelabs/ds-icons';
import { Typography } from '@saucelabs/ds-typography';
import { useButton } from 'react-aria';
import classnames from 'classnames';

import { BuildDetailsGroup } from './BuildDetailsGroup';
import { BuildDetailsDiffFragFragment } from '../../graphql/__generated__/graphql';
import { DiffGroupOrArray } from '../build-details/types';

export const BuildDetailsGroupSection: FC<BuildDetailsGroupSectionProps> = (props) => {
  const { entry, depth, isFirst } = props;
  const [isOpen, setIsOpen] = useState(true);

  const onToggle = useCallback(() => {
    setIsOpen((_isOpen) => !_isOpen);
  }, [setIsOpen]);

  const ref = useRef(null);
  const { buttonProps } = useButton({
    onPress: onToggle,
    elementType: 'div',
  }, ref);

  return (
    <div
      className=" ml-3 relative"
    >
      <div
        className={classnames('-left-0.5 top-2 w-px px-0.5 absolute cursor-pointer group', {
          hidden: !isOpen,
        })}
        onClick={onToggle}
        role="presentation"
        style={{ height: 'calc(100% - 16px)' }}
      >
        <div className="w-px h-full absolute top-0 left-0.5 bg-gray-200 group-hover:bg-blue-700" />
      </div>
      <div
        ref={ref}
        className="flex flex-row items-center px-2 pt-1.5 gap-1 pb-0.75 relative focus-ring cursor-pointer hover:text-blue-700 border-0 border-b border-solid border-transparent hover:border-gray-200"
        {...buttonProps}
      >
        <IconCaretDownFill className={classnames(
          'h-3 w-3 fill-current -ml-3.5 bg-white p-0.25 transition-transform',
          {
            'transform -rotate-90': !isOpen,
          },
        )}
        />
        <Typography
          className="m-0"
          disableSpacing
          variant="heading-5"
        >
          {entry[0]}
        </Typography>
      </div>
      <div className={!isOpen ? 'hidden' : undefined}>
        <BuildDetailsGroup
          depth={depth + 1}
          group={entry[1]}
          isFirst={isFirst}
        />
      </div>
    </div>
  );
};

export interface BuildDetailsGroupSectionProps {
  entry: [string, DiffGroupOrArray<BuildDetailsDiffFragFragment>];
  depth: number;
  isFirst?: boolean;
}
